import User from '@/models/User';

export default {
  state: () => ({
    user: null,
  }),

  mutations: {
    setUser(state, payload = null) {
      state.user = payload;
    },
  },

  getters: {
    user({ user }) {
      return user ? new User(user) : null;
    },
  },

  actions: {},
};
